// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableContainer_root__aWpCh"};